import { render, staticRenderFns } from "./SecretTTT.vue?vue&type=template&id=5c4e256c&"
import script from "./SecretTTT.vue?vue&type=script&lang=js&"
export * from "./SecretTTT.vue?vue&type=script&lang=js&"
import style0 from "./SecretTTT.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports